export default "__VITE_ASSET__CzR2ZoB6__"